/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    BadgeOutlined,
    CampaignOutlined,
    GrassOutlined,
    LayersOutlined,
    LocalShippingOutlined,
    MenuBookOutlined,
    ShoppingCartOutlined,
    BookmarkOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Catalogo from "./Secciones/Seccion_Catalogo";
import Seccion_Tipo from "./Secciones/Seccion_Tipo";
import Seccion_Anuncios from "./Secciones/Seccion_Anuncios";
import Seccion_Pedidos from "./Secciones/Seccion_Pedidos";
import Seccion_Adicional from "./Secciones/Seccion_Adicional";
import Seccion_Sectores from "./Secciones/Seccion_Sectores";
import Seccion_Reserva from "./Secciones/Seccion_Reserva";
import Seccion_Madurez from "./Secciones/Seccion_Madurez";
import Seccion_Origen from "./Secciones/Seccion_Origen";
import Seccion_Marcas from "./Secciones/Seccion_Marcas";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)
    const [open, setOpen] = useState(false)


    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir
    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Pedidos',
        icono: ShoppingCartOutlined,
        camino: '/Pedidos',
        categoria: 'Pedidos',
        Componente: <Seccion_Pedidos/>
    },
    {
        nombre: 'Catalogo',
        icono: MenuBookOutlined,
        camino: '/Catalogo',
        categoria: 'Pagina',
        Componente: <Seccion_Catalogo/>
    },
    {
        nombre: 'Anuncios',
        icono: CampaignOutlined,
        camino: '/Anuncios',
        categoria: 'Pagina',
        Componente: <Seccion_Anuncios/>
    },
    {
        nombre: 'Marcas',
        icono: BookmarkOutlined,
        camino: '/Marcas',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Marcas/>
    },
    {
        nombre: 'Tipo Agave',
        icono: GrassOutlined,
        camino: '/Tipo',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Tipo/>
    },
    {
        nombre: 'Tipo de Reserva',
        icono: GrassOutlined,
        camino: '/Reserva',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Reserva/>
    },
    {
        nombre: 'Madurez',
        icono: GrassOutlined,
        camino: '/Madurez',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Madurez/>
    },
    {
        nombre: 'Origen Agave',
        icono: GrassOutlined,
        camino: '/Origen',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Origen/>
    },
    {
        nombre: 'Sectores',
        icono: LocalShippingOutlined,
        camino: '/Sectores',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Sectores/>
    },

    {
        nombre: 'Adicionales',
        icono: LayersOutlined,
        camino: '/Adicionales',
        categoria: 'Configuraciones',
        Componente: <Seccion_Adicional/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}